// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Recipient
*/
export class TCQpSignatureModelRecipient {
    /**
    * @description Email
    */
    'email': string;
    /**
    * @description Name
    */
    'name': string;
    /**
    * @description Role
    */
    'role': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelRecipient>> = [
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "role",
            "baseName": "role",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelRecipient.attributeTypeMap;
    }
}
